import { ToggleButtonWithValue, typography } from '@ui';

import { useTranslate } from '@i18n';
import { UserPreferredUnit } from '@data';
import { Controller, useFormContext } from 'react-hook-form';

import * as css from './StudentSettings.css';

const units: UserPreferredUnit[] = ['metric', 'imperial', 'mixed'];

export const StudentUnits = () => {
    const { control } = useFormContext();

    const t = useTranslate();
    return (
        <div className={css.unitSettings}>
            <p
                className={typography({
                    variant: 'h4',
                })}
            >
                Units
            </p>
            <Controller
                control={control}
                name="userPreferredUnit"
                render={({ field }) => (
                    <div className={css.unitSettingsSelection}>
                        {units.map((unit) => (
                            <ToggleButtonWithValue
                                key={unit}
                                onSelect={field.onChange}
                                isActive={field.value === unit}
                                variant="radio"
                                value={unit}
                                typographyVariant="h4"
                            >
                                {t(`menu.user_settings_unit_${unit}`)}
                            </ToggleButtonWithValue>
                        ))}
                    </div>
                )}
            />
        </div>
    );
};
